export const ZOOM_LOCATION = 'uf.explore.stats.zoom_location';
export const CELL_TOOLTIP = 'uf.explore.stats.cell.tooltip';
export const COLUMN_REORDER = 'uf.explore.stats.column.reorder';
export const COLUMN_RESIZE = 'uf.explore.stats.column.resize';
export const COLUMN_FAVORITE = 'uf.explore.stats.column.favorite';
export const COLUMN_UNFAVORITE = 'uf.explore.stats.column.favorite';
export const COLUMN_SORT = 'uf.explore.stats.sort';
export const COLUMN_FREEZE = 'uf.explore.stats.column.freeze';
export const COLUMN_UNFREEZE = 'uf.explore.stats.column.unfreeze';
